<template>
    <div class="nav-content">
        <div class="support-box" :class="{mobile: this.$utils.isMobile()}">
            <div class="img-box">
                <img v-if="alipay==false" src="https://f0.anyknew.com/static/img/support-wechat-600.jpg" width="300">
                <img v-else src="https://f0.anyknew.com/static/img/support-alipay.png" width="300">
            </div>
            <div class="switch-method">
                <span v-if="alipay==false"  @click="toggleMethod">切换为支付宝</span>
                <span v-else  @click="toggleMethod">切换为微信</span>
            </div>
            <div class="info-box">
<!--                <p>我们也扭扭捏捏的在首页加上了赞赏功能...赞赏将用于接下来一年的服务器费用，<a href="https://www.anyknew.com/board/notifications/105">查看更多说明</a>。</p>-->
              <p>为Anyknew的持续运行充个电，感谢支持:)</p>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        name: 'support',
        data: function () {
            return {
                alipay: false
            }
        },
        created: function () {
        },
        methods:{
            toggleMethod: function () {
                this.alipay = !this.alipay
            },
            do_submit: function () {
                if(this.content.length < 10){
                    this.$utils.transitMsg('有点太少了，起码凑10个字吧', 2000)
                    return
                }
                var that = this
                this.$http.post('/feedback', {contact: this.contact, content: this.content}, function (r) {
                    if (r.status === 0) {
                        that.subed = true
                        that.contact = ''
                        that.content = ''
                    } else {
                        that.$utils.transitMsg(r.msg, 2000)
                    }
                })
            }

        }
    }
</script>

<style lang="less">
    .support-box{
        margin: auto;
        margin-top: 50px;
        width: 400px;
        border-radius: 5px;
        background-color: #FFFFFF;
        padding: 30px;
        &.mobile{
            width: 90%;
            margin-top: 35px;
            padding: 10px;
        }
        .img-box{
            text-align: center;
        }
        .switch-method{
            margin-top: 5px;
            text-align: center;
            font-size: 1rem;
            color: #3DB4F1;
        }
        .info-box{
            margin-top: 10px;
            text-align: center;
            color: #666666;
            font-size: 1rem;
            line-height: 1.5rem;
            p{margin: 5px auto}
            a{
                color: #3DB4F1;
            }
        }
    }

</style>
